import $ from 'jquery';

export default () => {
    let $cta = $(".cta-reset-quiz");
    let $s = $("#quizCarousel");

    $cta.click(e => {
        e.preventDefault(); 
        $s.find(".active").removeClass("active");
        $($s.find(".carousel-indicators button").get(0)).addClass("active");
        $($s.find(".carousel-inner div").get(0)).addClass("active");
    });
};



// WEBPACK FOOTER //
// ../views/partials/quiz/quiz.js